/* istanbul ignore file */
import { withStyles } from '@material-ui/core/styles';
import { Chip } from '@material-ui/core';

const StyledSearchChip = withStyles(() => ({
  label: {
    color: 'white',
  },
  root: {
    backgroundColor: '#00B5E2',
  },
}))(Chip);

export default StyledSearchChip;
